// ══════════════════════════════════════════════════════════════════════════════════════════════
//  t374 · LA TARJETA DE UNA CIFRA DE LucIA (`analizar`: el motor de métricas, fase 7c, 22-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Lo que devuelve backend/services/asistenteLuciaMetricas.js (tarjeta tipo 'serie'), pintado TAL CUAL: el total, sus cambios
//  con flecha (en verde lo que va bien: las faltas, al revés), la tendencia, una GRÁFICA sencilla y la tabla, con «PDF» y «Excel»
//  (los pide el panel a POST /api/asistente-lucia/metricas/ejecutar: el mismo cálculo, otra vez, con la sesión de la persona).
//  Las cifras ya vienen calculadas; aquí no se suma nada.
//
//  POR QUÉ ESTÁ EN utils/ Y SIN HOOKS (como utils/preguntarALucia.jsx, t369): el panel lo montan varias guardias con sus dobles, y
//  un `utils/` se carga de verdad en todas sin tocar ninguna (test-helpers/utilDelFrontend); sin hooks, lo que las guardias
//  expanden a mano no revienta. Por eso tampoco importa los iconos de components/ui: los dos que usa van dibujados aquí.
//
//  LA GRÁFICA, sin librerías (un SVG que se adapta al ancho del panel):
//   · líneas para una serie en el tiempo (2 px, puntos de 8 px, la rejilla en gris claro), barras para unos pocos totales y
//     barras horizontales para un desglose (los grupos, de mayor a menor, con su etiqueta y su valor escritos);
//   · los colores, los de la clínica: la serie principal en su color (--primary), la segunda en su secundario (--secundario) y
//     las demás en gris con otro trazo; con dos o más series, la leyenda debajo. El texto, siempre en los colores del texto.
//   · en oscuro, los mismos tokens del tema. Cada punto y cada barra lleva su valor al pasar por encima (y la tabla, debajo).
//  t452 · A SU MEDIDA (24-oct-2026): el panel le pasa a la tarjeta el ANCHO que tiene (`ancho`, en px: lo mide el panel, que sí
//  lleva hooks) y la gráfica se dibuja a ese ancho, no estirada: la letra sigue en su tamaño, sale más alta (hasta 300 px) y con
//  más fechas debajo cuantas más caben. Al cambiar el ancho (arrastrar el borde, ampliar el panel o volver) se dibuja otra vez.
//  A partir de 1000 px (el panel ampliado), la gráfica y la tabla van una al lado de la otra. Sin `ancho`, como siempre (320).
// Los dos iconos de la tarjeta (los mismos trazos que components/ui · Ico: «informes» y «download»).
import { t as i18nT } from './i18n.js'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

const IconoInformes = ({ s = 17 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ display: 'block' }}>
    <path d="M4 20 H20" /><path d="M6.5 20 V13.5" /><path d="M12 20 V8.5" /><path d="M17.5 20 V4.5" />
  </svg>
)
const IconoBajar = ({ s = 12 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ display: 'block' }}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
  </svg>
)

const caja = { display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: '8px', border: '1px solid var(--border)', borderRadius: '12px', padding: '10px 11px', background: 'var(--surface)' }
const menor = { fontSize: '12px', color: 'var(--text-muted)', overflowWrap: 'anywhere' }
const boton = { border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-primary)', borderRadius: '9px', padding: '5px 9px', fontSize: '12px', fontWeight: 700,
  cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }
const COLORES = ['var(--primary)', 'var(--secundario, var(--text-muted))', 'var(--text-muted)', 'var(--text-muted)', 'var(--text-muted)', 'var(--text-muted)']
const TRAZOS = ['', '', '5 3', '2 3', '8 3 2 3', '1 2']
const COLOR_CAMBIO = (c) => (c.bueno == null ? 'var(--text-muted)' : (c.bueno ? 'var(--success, #15803d)' : 'var(--danger)'))

// Las cifras de la gráfica, escritas como en el servidor (es-ES; los ejes, en corto).
const numEs = (n, d) => { try { return new Intl.NumberFormat('es-ES', { minimumFractionDigits: d, maximumFractionDigits: d }).format(n) } catch (_) { return String(n) } }
export function escribirCifra(v, unidad, corto = false) {
  if (v == null || !Number.isFinite(Number(v))) return '—'
  const n = Number(v)
  if (corto && Math.abs(n) >= 1000) return numEs(n / 1000, Math.abs(n) >= 10000 ? 0 : 1) + ' mil' + (unidad === 'euros' ? ' €' : '')
  switch (unidad) {
    case 'euros': return numEs(n, corto ? 0 : 2) + ' €'
    case 'euros_hora': return numEs(n, corto ? 0 : 2) + ' €/h'
    case 'pct': return numEs(n, 1) + ' %'
    case 'horas': return numEs(n, 1) + ' h'
    case 'dias': return numEs(n, 1) + ' d'
    case 'nota': return numEs(n, 1)
    default: return numEs(n, Number.isInteger(n) ? 0 : 1)
  }
}

function Flecha({ c }) {
  if (!c || !c.texto) return null
  return (
    <span data-cambio={c.flecha} style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', color: COLOR_CAMBIO(c), fontWeight: 700, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
      {c.flecha !== 'igual' && (
        <svg width="11" height="11" viewBox="0 0 24 24" aria-hidden="true" style={{ transform: c.flecha === 'baja' ? 'rotate(180deg)' : 'none' }}>
          <path d="M12 4 L20 14 H14 V20 H10 V14 H4 Z" fill="currentColor" />
        </svg>
      )}
      <span>{c.texto}</span>
    </span>
  )
}

// ── LAS LÍNEAS (y las barras verticales) ─────────────────────────────────────────────────────────
// El ancho del dibujo es el de la tarjeta (t452): de 240 a 2400 px; el alto, el 30 % del ancho, entre 150 y 300.
const AN_DE_SIEMPRE = 320; const IZQ = 44; const DER = 8; const ARR = 10; const ABA = 22
export function medidasGrafica(ancho) {
  const n = Number(ancho)
  const an = Number.isFinite(n) && n > 0 ? Math.round(Math.min(2400, Math.max(240, n))) : AN_DE_SIEMPRE
  return { an, al: Math.round(Math.min(300, Math.max(150, an * 0.3))) }
}
// Qué etiquetas se escriben debajo: la primera, la última y, entre medias, las que quepan a 110 px una de otra, a saltos iguales
// (una de cada `paso`); la de antes de la última se quita si queda pegada a ella.
export function marcasDelEje(n, an) {
  if (n <= 0) return []
  if (n <= 2) return [...new Set([0, n - 1])]
  const caben = Math.max(3, Math.min(n, Math.floor((an - IZQ - DER) / 110) + 1))
  const paso = Math.max(1, Math.ceil((n - 1) / (caben - 1)))
  const out = []
  for (let i = 0; i < n - 1; i += paso) out.push(i)
  if (out.length > 1 && (n - 1) - out[out.length - 1] <= paso / 2) out.pop()
  out.push(n - 1)
  return out
}
function escala(series, AL) {
  const vals = series.flatMap((s) => s.valores).filter((v) => v != null && Number.isFinite(Number(v))).map(Number)
  let min = Math.min(0, ...vals); let max = Math.max(0, ...vals)
  if (max === min) max = min + 1
  return { min, max, y: (v) => ARR + (AL - ARR - ABA) * (1 - (Number(v) - min) / (max - min)) }
}
function GraficaLineas({ g, ancho }) {
  const series = (g.series || []).slice(0, 6)
  const n = (g.etiquetas || []).length
  if (!n) return null
  const { an: AN, al: AL } = medidasGrafica(ancho)
  const { min, max, y } = escala(series, AL)
  const x = (i) => IZQ + (n === 1 ? (AN - IZQ - DER) / 2 : (i * (AN - IZQ - DER)) / (n - 1))
  const marcas = marcasDelEje(n, AN)
  const conPuntos = n <= Math.max(40, Math.floor((AN - IZQ - DER) / 14))
  return (
    <svg viewBox={`0 0 ${AN} ${AL}`} width="100%" role="img" aria-label={i18nT('utils.tarjetaSerieLucia.grafica_de_lineas', 'Gráfica de líneas: {{lista}}', { lista: series.map((s) => s.nombre).join(', ') })} style={{ display: 'block', overflow: 'visible' }}>
      {[min, (min + max) / 2, max].map((v, i) => (
        <g key={'r' + i}>
          <line x1={IZQ} x2={AN - DER} y1={y(v)} y2={y(v)} stroke="var(--border)" strokeWidth="1" />
          <text x={IZQ - 5} y={y(v) + 3.5} textAnchor="end" fontSize="9.5" fill="var(--text-muted)">{escribirCifra(v, g.unidad, true)}</text>
        </g>
      ))}
      {marcas.map((i) => (
        <text key={'e' + i} x={x(i)} y={AL - 6} textAnchor={i === 0 ? 'start' : (i === n - 1 ? 'end' : 'middle')} fontSize="9.5" fill="var(--text-muted)">{String(g.etiquetas[i]).slice(0, 14)}</text>
      ))}
      {series.map((s, k) => {
        const pts = s.valores.map((v, i) => (v == null ? null : [x(i), y(v)]))
        const tramos = []; let actual = []
        for (const p of pts) { if (p) actual.push(p); else if (actual.length) { tramos.push(actual); actual = [] } }
        if (actual.length) tramos.push(actual)
        return (
          <g key={'s' + k} data-serie={k}>
            {tramos.map((t, j) => <polyline key={j} points={t.map((p) => p.join(',')).join(' ')} fill="none" stroke={COLORES[k]} strokeWidth="2" strokeDasharray={TRAZOS[k] || undefined} strokeLinejoin="round" strokeLinecap="round" />)}
            {conPuntos && pts.map((p, i) => p && (
              <circle key={i} cx={p[0]} cy={p[1]} r="4" fill={COLORES[k]} stroke="var(--surface)" strokeWidth="2">
                <title>{s.nombre + ' · ' + g.etiquetas[i] + ': ' + escribirCifra(s.valores[i], g.unidad)}</title>
              </circle>
            ))}
          </g>
        )
      })}
    </svg>
  )
}
function GraficaBarras({ g, ancho: anchoTarjeta }) {
  const s = (g.series || [])[0]
  const n = (g.etiquetas || []).length
  if (!s || !n) return null
  const { an: AN, al: AL } = medidasGrafica(anchoTarjeta)
  const { y } = escala([s], AL)
  const ancho = (AN - IZQ - DER) / n
  const cero = y(0)
  // Las etiquetas de debajo, si caben (22 px por barra o más); y más largas cuanto más ancha es cada barra.
  const conEtiquetas = ancho >= 22
  const letras = Math.min(18, Math.max(10, Math.floor(ancho / 6)))
  return (
    <svg viewBox={`0 0 ${AN} ${AL}`} width="100%" role="img" aria-label={i18nT('utils.tarjetaSerieLucia.grafica_de_barras', 'Gráfica de barras: {{nombre}}', { nombre: s.nombre })} style={{ display: 'block' }}>
      <line x1={IZQ} x2={AN - DER} y1={cero} y2={cero} stroke="var(--border)" strokeWidth="1" />
      {s.valores.map((v, i) => {
        if (v == null) return null
        const alto = Math.max(1, Math.abs(cero - y(v)))
        const bx = IZQ + i * ancho + 1; const bw = Math.max(2, ancho - 2)
        return (
          <g key={i}>
            <rect x={bx} y={Number(v) >= 0 ? cero - alto : cero} width={bw} height={alto} rx="4" fill={i === n - 1 ? 'var(--primary)' : 'color-mix(in srgb, var(--primary) 55%, var(--surface))'}>
              <title>{g.etiquetas[i] + ': ' + escribirCifra(v, g.unidad)}</title>
            </rect>
            {conEtiquetas && <text x={bx + bw / 2} y={AL - 6} textAnchor="middle" fontSize="9.5" fill="var(--text-muted)">{String(g.etiquetas[i]).slice(0, letras)}</text>}
          </g>
        )
      })}
      {[0, s.valores.length - 1].filter((i, k, l) => l.indexOf(i) === k && s.valores[i] != null).map((i) => (
        <text key={'v' + i} x={IZQ + i * ancho + ancho / 2} y={Math.min(cero, y(s.valores[i])) - 3} textAnchor="middle" fontSize="9.5" fill="var(--text-primary)" fontWeight="700">{escribirCifra(s.valores[i], g.unidad, true)}</text>
      ))}
    </svg>
  )
}
// Las barras horizontales de un desglose: HTML (se lee mejor y se adapta a cualquier ancho), de mayor a menor.
function BarrasHorizontales({ g }) {
  const s = (g.series || [])[0]
  if (!s) return null
  const max = Math.max(...s.valores.filter((v) => v != null).map((v) => Math.abs(Number(v))), 0) || 1
  return (
    <div role="list" aria-label={i18nT('utils.tarjetaSerieLucia.grafica_de_barras', 'Gráfica de barras: {{nombre}}', { nombre: s.nombre })} style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
      {g.etiquetas.map((e, i) => (
        <div key={i} role="listitem" title={e + ': ' + escribirCifra(s.valores[i], g.unidad)} style={{ display: 'grid', gridTemplateColumns: 'minmax(0, min(38%, 260px)) minmax(0, 1fr) auto', alignItems: 'center', gap: '7px', fontSize: '12px' }}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: 'var(--text-primary)' }}>{e}</span>
          <span style={{ height: '10px', borderRadius: '4px', background: 'color-mix(in srgb, var(--primary) 12%, var(--surface))', overflow: 'hidden' }}>
            <span style={{ display: 'block', height: '100%', width: Math.max(2, (Math.abs(Number(s.valores[i]) || 0) / max) * 100) + '%', background: 'var(--primary)', borderRadius: '4px' }} />
          </span>
          <b style={{ fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>{escribirCifra(s.valores[i], g.unidad)}</b>
        </div>
      ))}
    </div>
  )
}
export function Grafica({ g, ancho }) {
  if (!g || !Array.isArray(g.series) || !g.series.length) return null
  const cuerpo = g.horizontal ? <BarrasHorizontales g={g} /> : (g.tipo === 'lineas' ? <GraficaLineas g={g} ancho={ancho} /> : <GraficaBarras g={g} ancho={ancho} />)
  return (
    <div data-asistente-grafica={g.horizontal ? 'horizontal' : g.tipo} style={{ minWidth: 0 }}>
      {cuerpo}
      {!g.horizontal && g.series.length > 1 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 12px', marginTop: '4px', ...menor }}>
          {g.series.slice(0, 6).map((s, k) => (
            <span key={k} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', color: 'var(--text-secondary, var(--text-muted))' }}>
              <svg width="18" height="8" aria-hidden="true"><line x1="1" x2="17" y1="4" y2="4" stroke={COLORES[k]} strokeWidth="2.5" strokeDasharray={TRAZOS[k] || undefined} strokeLinecap="round" /></svg>
              {s.nombre}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

// Toda la tabla de la tarjeta (hasta 60 filas), en una caja que se desplaza (también de lado, si sus columnas no caben: la página
// no se mueve); con todas sus filas, en el Excel. t452 · Al lado de la gráfica, tan alta como ella y sin partir las etiquetas
// («ene 2026» en una línea: la tabla ya se desplaza de lado si no cabe).
const hayTabla = (t) => !!(t && t.tabla && Array.isArray(t.tabla.columnas) && t.tabla.columnas.length && Array.isArray(t.tabla.filas) && t.tabla.filas.length)
function Tabla({ t, alto = 240, sinPartir = false }) {
  if (!hayTabla(t)) return null
  const tabla = t.tabla
  const columnas = tabla.columnas
  const filas = tabla.filas
  // t532 · B-2271 · en el detalle línea a línea cada columna de cifras trae su unidad (el importe en euros, una cuenta en número).
  const celda = (c, v) => (c.tipo === 'num' ? escribirCifra(v, c.unidad || (c.key === 'parte' ? 'pct' : t.unidad)) : (v == null ? '' : String(v)))
  return (
    <div style={{ minWidth: 0 }}>
      <div data-asistente-tabla="" style={{ overflow: 'auto', maxHeight: alto + 'px', border: '1px solid var(--border)', borderRadius: '9px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11.5px' }}>
          <thead>
            <tr>{columnas.map((c) => <th key={c.key} style={{ textAlign: c.tipo === 'num' ? 'right' : 'left', padding: '5px 7px', borderBottom: '1px solid var(--border)', color: 'var(--text-muted)', fontWeight: 700, whiteSpace: 'nowrap' }}>{c.label}</th>)}</tr>
          </thead>
          <tbody>
            {filas.map((f, i) => (
              <tr key={i}>{columnas.map((c) => <td key={c.key} style={{ textAlign: c.tipo === 'num' ? 'right' : 'left', padding: '4px 7px', borderTop: i ? '1px solid var(--border)' : 'none', fontVariantNumeric: 'tabular-nums', whiteSpace: c.tipo === 'num' || sinPartir ? 'nowrap' : 'normal' }}>{celda(c, f[c.key])}</td>)}</tr>
            ))}
          </tbody>
        </table>
      </div>
      {tabla.mas > 0 && <div style={{ ...menor, marginTop: '4px' }}>y {tabla.mas} filas más en el Excel</div>}
    </div>
  )
}

// A partir de este ancho de tarjeta (el panel ampliado), la gráfica y la tabla van una al lado de la otra (3 a 2).
export const ANCHO_LADO_A_LADO = 1000
export function TarjetaSerie({ t, onDescargar, ancho }) {
  const cambios = Array.isArray(t.cambios) ? t.cambios : []
  const interior = Number(ancho) > 0 ? Math.max(240, Math.round(Number(ancho)) - 24) : null
  const conGrafica = !!(t.grafica && Array.isArray(t.grafica.series) && t.grafica.series.length)
  const lado = interior != null && Number(ancho) >= ANCHO_LADO_A_LADO && conGrafica && hayTabla(t)
  const anGrafica = lado ? Math.round(((interior - 16) * 3) / 5) : interior
  const altoTabla = lado ? medidasGrafica(anGrafica).al + 24 : 240
  return (
    <div data-asistente-tarjeta="serie" style={{ ...caja, minWidth: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span aria-hidden="true" style={{ width: '34px', height: '34px', borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'color-mix(in srgb, var(--primary) 13%, var(--surface))', color: 'var(--primary)' }}>
          <IconoInformes s={17} />
        </span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 800, fontSize: '13.5px', overflowWrap: 'anywhere' }}>{t.titulo}</div>
          <div style={menor}>{[t.periodo, t.filtros].filter(Boolean).join(' · ')}</div>
        </div>
      </div>
      {t.total && (
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>{t.total.etiqueta}</span>
          <b data-asistente-total="" style={{ fontSize: '20px', fontVariantNumeric: 'tabular-nums' }}>{t.total.valor}</b>
          {t.tendencia && <span style={menor}>tendencia: {t.tendencia}</span>}
        </div>
      )}
      {cambios.map((c, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'baseline', gap: '6px', flexWrap: 'wrap', fontSize: '12px', color: 'var(--text-secondary, var(--text-muted))' }}>
          <span style={{ minWidth: 0, overflowWrap: 'anywhere' }}>{c.etiqueta}: <b style={{ color: 'var(--text-primary)', fontVariantNumeric: 'tabular-nums' }}>{c.valor}</b></span>
          <Flecha c={c} />
        </div>
      ))}
      {lado
        ? (
          <div data-asistente-lado-a-lado="" style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 3fr) minmax(0, 2fr)', gap: '16px', alignItems: 'start' }}>
            <Grafica g={t.grafica} ancho={anGrafica} />
            <Tabla t={t} alto={altoTabla} sinPartir />
          </div>
        )
        : [<Grafica key="g" g={t.grafica} ancho={anGrafica} />, <Tabla key="t" t={t} alto={altoTabla} />]}
      {(Array.isArray(t.notas) ? t.notas : []).map((n, i) => <div key={i} role="note" style={menor}>{n}</div>)}
      {Array.isArray(t.descargas) && t.descargas.length > 0 && onDescargar && (
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
          {/* t532 · B-2271 · el formato que se ha pedido («sácamelo en Excel», «en PDF») va destacado: es el botón que tiene que pulsar */}
          {t.descargas.map((d) => (
            <button key={d.formato} type="button" data-asistente-descargar={d.formato} data-destacado={t.destacar === d.formato ? '' : undefined} onClick={() => onDescargar(t, d)}
              style={t.destacar === d.formato ? { ...boton, background: 'var(--primary)', borderColor: 'var(--primary)', color: 'var(--sobre-primary, #fff)' } : boton}>
              <IconoBajar s={12} /> {d.texto}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
